// extracted by mini-css-extract-plugin
export var productImage = "_qp-1";
export var viewLink = "_qp-2";
export var wishlistItem = "_qp-0";